<div class="container-fluid">
<mat-card >
    <mat-card-title>Module Wise Build Details</mat-card-title>

    <mat-card-content>
        <div class="mat-elevation-z8 mt-3">
            <dynamic-grid [rows]="rowBuildArray" [cols]="colBuildArray" [showSearch]="false" [canAddRow]="false"
                [isEditable]="false" [isSaveAll]="false" [addRowAtTop]="false" [isLoading]="false"
                [isExternalSearch]="false" [canEditInline]="false" [isRowSelectable]="false"
                [colPropConfig]="colPropConfig" [comboPropConfig]="comboPropConfig" 
                [allowMultiRowSelection]="false"
                [showCheckboxForSelection]="false" [pageSize]="5" [isExternalPaging]="false"
               ></dynamic-grid>
        </div>

    </mat-card-content>
</mat-card>
</div>